var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"image-preview-container"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{staticClass:"preview-image",attrs:{"src":_vm.imageUrl,"alt":"预览图片"}}),_c('div',{staticClass:"close-button",on:{"click":_vm.closeDialog}},[_c('i',{staticClass:"el-icon-close"})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }